/**
 * The mark on a row of the patient's allergies, medical history, medications or medical team that the patient
 * reported: on their invite, or in the patient app and accepted into the file by a member of the practice. Rows the
 * practice entered (and rows from before this was recorded) carry none.
 */
export interface ListRowSource {
  source?: string | null;
  acceptedAt?: string | Date | null;
}

const day = (value: string | Date) =>
  new Date(value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Africa/Johannesburg' });

export function patientReportedLabel(row: ListRowSource | null | undefined): string | null {
  if (row?.source === 'invite') return 'Patient reported on their invite';
  if (row?.source === 'patient_app') return `Patient reported in the patient app${row.acceptedAt ? `, accepted ${day(row.acceptedAt)}` : ''}`;
  return null;
}

/** A row's tooltip with the mark after it, when there is one. */
export function withPatientReported(tooltip: string, row: ListRowSource | null | undefined): string {
  const label = patientReportedLabel(row);
  return label ? `${tooltip} · ${label}` : tooltip;
}
